"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var stripeStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        title: {
            paddingBottom: '10px',
            fontWeight: typography.fontWeightBold,
        },
        description: {
            minHeight: '50px',
            lineHeight: '40px',
            fontWeight: typography.fontWeightLight,
            display: 'block',
        },
        email: {
            display: 'inline',
            color: palette.primary.main,
            textDecoration: 'underline',
            fontSize: typography.fontMD,
        },
        description2: {
            fontSize: typography.fontMD,
            textAlign: 'center',
            marginTop: '20px',
            display: 'block',
        },
        payButton: {
            margin: '30px auto',
            display: 'block',
        },
        hidePaymentButton: {
            display: 'none',
        },
    });
}, { name: 'Gql_Stripe' });
exports.default = stripeStyles;
